import React from 'react';

export default function StatusBadge({ status }) {
  const map = {
    encontrado: { cls: 'badge-success', text: 'Encontrado' },
    nao_encontrado: { cls: 'badge-danger', text: 'Não encontrado' },
    ocupado: { cls: 'badge-danger', text: 'Ocupado' },
    livre: { cls: 'badge-success', text: 'Livre' },
    lead: { cls: 'badge-info', text: 'Lead' },
  };
  const conf = map[status] || { cls: 'badge-info', text: status };
  return <span className={`badge ${conf.cls}`}>{conf.text}</span>;
}
